import React from "react";
import "./Wcu.css";

import handshake from "../../../handshake.png";
import authentic from "../../../authentic.png";
import recycle from "../../../recycle.png";
import plane from "../../../plane.png";
import firework from "../../../splashpng.png";
import shapewave from "../../../wave.png";

const Wcu = () => {
  const wcuItems = [
    {
      image: handshake,
      alt: "Trusted partnership with local artisans",
      text: (
        <>
          Trusted <b>Partnership</b> with Local Artisans
        </>
      ),
    },
    {
      image: authentic,
      alt: "Authentic Nepalese products",
      text: (
        <>
          <b>Authentic</b> Nepalese Products
        </>
      ),
    },
    {
      image: recycle,
      alt: "Sustainable and ethical sourcing",
      text: (
        <>
          Sustainable and <b>Ethical</b> Sourcing
        </>
      ),
    },
    {
      image: plane,
      alt: "Global shipping and easy returns",
      text: (
        <>
          <b>Global</b> Shipping & Easy Returns
        </>
      ),
    },
  ];

  return (
    <div className="Wcu-main-div">
      {/* <img src={shapewave} className="waveshape" alt="" /> */}

      <div className="container Wcu-internal">
        <div className="row Wcu-content-row">
          <div className="col-md-7 text-center Wcu-leftdiv">
            <h2 className="Wcu-title">
              Why <span className="Wcu-title-span">Choose</span> Us?
            </h2>

            <div className="internal-boxes-div">
              {wcuItems.map((item, index) => (
                <div className="items-Wcu-div" key={index}>
                  <div className="img-div-Wcu">
                    <img className="image-wcu" src={item.image} alt={item.alt} />
                  </div>

                  <p className="name-img-wcu">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-5 firwork-side">
            <div className="firework-div">
              <img
                src={firework}
                className="firework-img"
                alt="Nepali cultural illustration"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <img src={shapewave} className="waveshapeb" alt="" /> */}
    </div>
  );
};

export default Wcu;